import { Button, Typography } from '@/ui';

import type { RunStatus } from '@/store/api/mcpMemberApi';
import type { FC } from 'react';

import {
  useGetCoachingNotesQuery,
  useRegenerateCoachingNotesMutation,
} from '@/store/api/mcpMemberApi';

export const RUN_POLL_INTERVAL_MS = 5000;

// Mounted only while a run is in flight. RTK Query polls the shared
// getCoachingNotes cache entry for every subscriber; unmounting stops it.
const RunPoller = () => {
  useGetCoachingNotesQuery(undefined, {
    pollingInterval: RUN_POLL_INTERVAL_MS,
  });
  return null;
};

// Spec §8: generation in flight / failed. The run error text is never shown.
// NEW COPY (from spec §8, not the prototype): "Updating your notes…",
// "Couldn’t refresh", "Try again".
const RunStatusBanner: FC<{ run: RunStatus | undefined }> = ({ run }) => {
  const [regenerate, { isLoading }] = useRegenerateCoachingNotesMutation();
  if (run?.status === 'queued' || run?.status === 'running') {
    return (
      <>
        <RunPoller />
        <Typography className="mb-4 text-cement-400" variant="body2">
          Updating your notes…
        </Typography>
      </>
    );
  }
  if (run?.status === 'failed') {
    return (
      <div className="mb-4 flex items-center gap-3">
        <Typography className="text-cement-400" variant="body2">
          Couldn’t refresh
        </Typography>
        <Button
          loading={isLoading}
          size="small"
          variant="text"
          onClick={() => {
            regenerate()
              .unwrap()
              .catch(() => undefined);
          }}
        >
          Try again
        </Button>
      </div>
    );
  }
  return null;
};

export default RunStatusBanner;
